"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable indent */
var client_1 = require("@apollo/client");
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var Button_1 = __importDefault(require("../../../common/Button/Button"));
var TextInput_1 = __importDefault(require("../../../common/TextInput/TextInput"));
var localStorage_1 = __importDefault(require("../../../config/localStorage"));
var country_hook_1 = require("../../../context/CountryContext/country.hook");
var userContext_1 = require("../../../context/UserContext/userContext");
var roles_1 = require("../../../router/roles");
var icons_1 = __importDefault(require("../../../theme/icons"));
var Country_1 = __importDefault(require("../../Admin/Country/Country"));
var LanguageSelector_1 = __importDefault(require("../../LanguageSelector/LanguageSelector"));
var RoleSelector_1 = __importDefault(require("../../Role/RoleSelector"));
require("../Style/login.sass");
var validate_1 = require("../validate");
function Login() {
    var _this = this;
    var history = (0, react_router_dom_1.useHistory)(), _a = (0, react_1.useState)({
        username: '',
        password: '',
        role: '',
        country_code: '',
    }), loginPayload = _a[0], setLoginPayload = _a[1], _b = (0, react_1.useState)({
        error: null,
        success: null,
        loading: false,
    }), status = _b[0], setStatus = _b[1], client = (0, client_1.useApolloClient)(), setCurrentUser = (0, react_1.useContext)(userContext_1.UserContext).setCurrentUser, _c = (0, country_hook_1.useCountry)(), country = _c.country, setCurrentCountry = _c.setCurrentCountry, handleChange = function (value, type) {
        setStatus({
            error: null,
            loading: false,
            success: null,
        });
        setLoginPayload(function (prevState) {
            var _a;
            return (__assign(__assign({}, prevState), (_a = {}, _a[type] = value, _a)));
        });
    }, login = function () { return __awaiter(_this, void 0, void 0, function () {
        var res, item, err;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setStatus({
                        error: null,
                        loading: true,
                        success: null,
                    });
                    return [4 /*yield*/, (0, validate_1.validate)(loginPayload, client)];
                case 1:
                    res = _a.sent();
                    if (!(res.status === 'success')) return [3 /*break*/, 3];
                    item = res.result;
                    setCurrentUser(item);
                    return [4 /*yield*/, localStorage_1.default.setItem('user', item)];
                case 2:
                    _a.sent();
                    setStatus({
                        error: null,
                        loading: false,
                        success: null,
                    });
                    if (roles_1.roles.admins.includes(item.role.name)) {
                        history.replace('admin/organization');
                    }
                    else {
                        setStatus({
                            error: {
                                status: 'error',
                                field: 'role',
                                message: 'invalid_credentials',
                            },
                            loading: false,
                            success: null,
                        });
                    }
                    return [3 /*break*/, 4];
                case 3:
                    if (res === null || res === void 0 ? void 0 : res.field) {
                        setStatus({
                            error: res,
                            loading: false,
                            success: null,
                        });
                    }
                    else {
                        err = {
                            status: 'error',
                            field: 'role',
                            message: res.message,
                        };
                        setStatus({
                            error: err,
                            loading: false,
                            success: null,
                        });
                    }
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: 'login' },
            react_1.default.createElement("div", { className: 'left' }),
            react_1.default.createElement("div", { className: 'right' },
                react_1.default.createElement("div", { className: 'login-box' },
                    react_1.default.createElement("div", { className: 'logo-container', style: { marginTop: 0 } },
                        react_1.default.createElement(icons_1.default, { height: 80, name: 'logo', width: 80 }),
                        react_1.default.createElement(icons_1.default, { className: 'icon_black', height: 80, name: 'AcornAppIcon', width: 220 })),
                    react_1.default.createElement(Country_1.default, { error: status.error &&
                            status.error.field === 'country_code' &&
                            status.error.message, selectedCountry: function (val) { return handleChange(val, 'country_code'); } }),
                    react_1.default.createElement(LanguageSelector_1.default, { country: loginPayload.country_code }),
                    react_1.default.createElement(TextInput_1.default, { error: status.error &&
                            status.error.field === 'username' &&
                            status.error.message, icon: react_1.default.createElement(icons_1.default, { className: 'icon_orange', height: 32, name: 'user', width: 32 }), onChange: function (e) { return handleChange(e.target.value, 'username'); }, placeholder: 'umva_id', value: loginPayload.username }),
                    react_1.default.createElement(TextInput_1.default, { error: status.error &&
                            status.error.field === 'password' &&
                            status.error.message, icon: react_1.default.createElement(icons_1.default, { className: 'icon_orange', height: 32, name: 'key', width: 32 }), onChange: function (e) { return handleChange(e.target.value, 'password'); }, placeholder: 'password', type: 'password', value: loginPayload.password }),
                    react_1.default.createElement(RoleSelector_1.default, { error: status.error &&
                            status.error.field === 'role' &&
                            status.error.message, onChange: function (e) { return handleChange(e.value, 'role'); }, placeholder: 'select role', value: loginPayload.role }),
                    react_1.default.createElement(Button_1.default, { className: 'btn-primary', name: 'Login', onClick: login, text: 'Login' }))))));
}
exports.default = Login;
